import React from 'react'

export default function Section3() {
    return (
        <div className='w-[90%] mx-auto pb-10 lg:pb-20'>
            <h1 className='text-[#269DDF] text-center font-bold text-2xl lg:text-3xl' data-aos='fade-up' data-aos-duration='1500'>HOW IT WORKS</h1>
            <div className='bg-[#2B659645] p-7 lg:p-10 rounded-3xl mt-5 grid md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-10'>
                <div  data-aos='fade-up' data-aos-duration='1000'>
                    <div className='flex items-center justify-center relative'>
                        <img src='/assets/icons/no_1.svg' className='mx-auto relative'></img>
                        <img src='/assets/icons/no_1arrow.svg' className='absolute w-20 top-3.5 ani-spin'></img>
                    </div>
                    <h1 className='font-bold text-center uppercase josefin-sans-regular'>Onboarding</h1>
                    <p className='mt-2 text-justify'>Sign up and complete the onboarding process. The platform will verify your request and proceed with the onboarding process. </p>
                </div>
                <div  data-aos='fade-up' data-aos-duration='1500'>
                    <div className='flex items-center justify-center relative'>
                        <img src='/assets/icons/no_2.svg' className='mx-auto relative'></img>
                        <img src='/assets/icons/no_2arrow.svg' className='absolute w-20 top-3.5 ani-spin'></img>
                    </div>
                    <h1 className='font-bold text-center uppercase josefin-sans-regular'>Funding Your Wallet </h1>
                    <p className='mt-2 text-justify'>Deposit the required funds (crypto or fiat) into your wallet to ensure smooth order execution. All OTC trades will be conducted through your wallet, ensuring secure and seamless transactions. </p>
                </div>
                <div  data-aos='fade-up' data-aos-duration='2000'>
                    <div className='flex items-center justify-center relative'>
                        <img src='/assets/icons/no_3.svg' className='mx-auto relative'></img>
                        <img src='/assets/icons/no_3arrow.svg' className='absolute w-20 top-3.5 ani-spin'></img>
                    </div>
                    <h1 className='font-bold text-center uppercase josefin-sans-regular'>Placing an Order </h1>
                    <p className='mt-2 text-justify'>Select the currency, set your desired order volume, and place your order with a single click.</p>
                </div>
                <div  data-aos='fade-up' data-aos-duration='2500'>
                    <div className='flex items-center justify-center relative'>
                        <img src='/assets/icons/no_4.svg' className='mx-auto relative'></img>
                        <img src='/assets/icons/no_4arrow.svg' className='absolute w-20 top-3.5 ani-spin'></img>
                    </div>
                    <h1 className='font-bold text-center uppercase josefin-sans-regular'>Settlement</h1>
                    <p className='mt-2 text-justify'>The platform will execute  your order. Any applicable fees will be automatically deducted from your wallet once the order is settled. </p>
                </div>
            </div>
        </div>
    )
}
